import { useEffect } from 'react';

import {
  trackTimeElapsedDuringEnrollment,
  trackTimeElapsedOnPage,
} from 'utils/segment/trackingEvents';
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInLocalStorage,
} from 'utils/storage/storageHelper';

import { useApplicationStats } from './useApplicationStats';

export const APP_STATS_TIME_ON_PAGE = 'app_stats_time_on_page';

export function useCaptureTimeOnPage(pageLabel) {
  const [, updateApplicationStats] = useApplicationStats(
    APP_STATS_TIME_ON_PAGE
  );

  const cookieKey = `time_spent_${pageLabel}_page`;

  function storeTimeLandedOnPage(pageLabel) {
    const pageKey = `${pageLabel}-timestamp`;
    const currentTime = Date.now();
    const alreadyStored = getFromLocalStorage(pageKey);

    if (!alreadyStored) setInLocalStorage(pageKey, currentTime);
  }

  function sendTimeToCompletePage(pageLabel) {
    const pageKey = `${pageLabel}-timestamp`;
    const currentTime = Date.now();
    const landedTime = JSON.parse(getFromLocalStorage(pageKey));

    const timeElapsedOnPage = currentTime - landedTime;

    trackTimeElapsedOnPage(pageLabel, timeElapsedOnPage);
    updateApplicationStats(cookieKey, timeElapsedOnPage);
    removeFromLocalStorage(pageKey);
  }

  useEffect(() => {
    storeTimeLandedOnPage(pageLabel);
  }, []);

  return {
    sendTimeToCompletePage: () => sendTimeToCompletePage(pageLabel),
  };
}

export function storeEnrollmentStartedTime() {
  setInLocalStorage('enrollment_started', Date.now());
}

export function useTimeToCompleteEnrollment() {
  function sendTimeElapsedDuringEnrollment() {
    const currentTime = Date.now();
    const landedTime = JSON.parse(getFromLocalStorage('enrollment_started'));

    const timeElapsed = currentTime - landedTime;

    trackTimeElapsedDuringEnrollment(timeElapsed);
  }

  useEffect(() => {
    sendTimeElapsedDuringEnrollment();
  }, []);
}
